export default __webpack_public_path__ + "static/media/login.212f2fca.png";